<!--
 * @Description: 客户账号详情-合同信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-17 14:40:09
 * @LastEditors: cxh
-->
<template>
  <a-form>
    <DetailCard
      v-for="(item, index) in data"
      :key="index"
      :columns="columns"
      :title="`合同信息${index + 1}`"
      :data="item"
    >
      <template #subTitle>
        <dc-layout-button-group>
          <a-button type="primary" @click="viewPdf(item)">原件预览</a-button>
          <a-button @click="showEditModal(item)">变更合同编码</a-button>
        </dc-layout-button-group>
      </template>
    </DetailCard>
    <dc-layout-empty type="nothing" v-if="!data || !data.length" />
  </a-form>
  <cos-footer-button :loading="loading" :returnName="returnName" :hideOk="true" />
  <cos-modal v-model:visible="visible" title="变更合同编码" width="470px" @ok="updateCode" :confirmLoading="loading">
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="contractCode" label="原合同编码" :rules="[{ required: true, message: '请输入' }]">
        <CosInput v-model:value="editForm.contractCode" :disabled="true" />
      </a-form-item>
      <a-form-item name="newContractCode" label="新合同编码" :rules="[{ required: true, message: '请输入' }]">
        <CosInput v-model:value="editForm.newContractCode" placeholder="请输入" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { queryContractDetail, contractCodeUpdate } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'
import { DcMessage } from '@dc-platform/dc-components'
import type { ContractItem } from '@/typings/api/customerCenter'
export default { name: 'tabsContract ' }
</script>
<script setup lang="ts">
const route = useRoute()
defineProps({
  returnName: String
})
const visible = ref(false)
const formRef = ref()
const loading = ref(false)
const editForm = ref<ContractItem>({})
const data = ref<ContractItem[]>([])
const columns = ref([
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '合同ID', dataIndex: 'id' },
  { title: '法务合同编码', dataIndex: 'contractCode' },
  { title: '签约业务', dataIndex: 'contractBusiness' },
  {
    title: '服务主体',
    dataIndex: 'serviceSubject',
    node: 'ParamCodesSelect',
    attrs: {
      paramCode: 'fbu_service_body',
      appId: 'cos_fbu',
      view: true
    }
  },
  { title: '合同类型', dataIndex: 'contractType' },
  { title: '线下合同数据同步时间', dataIndex: 'offlineSyncTime' },
  { title: '业务三级分类', dataIndex: 'businessThirdCate' },
  { title: '我方联系人姓名', dataIndex: 'contactName' },
  { title: '我方联系人手机号', dataIndex: 'contactMobile' },
  { title: '我方联系人邮箱', dataIndex: 'contactEmail' },
  { title: '对方联系人姓名', dataIndex: 'counterpartContactName' },
  { title: '对方联系人手机号', dataIndex: 'counterpartContactMobile' },
  { title: '对方联系人邮箱', dataIndex: 'counterpartContactEmail' },
  { title: '当前客户负责人', dataIndex: 'seller' },
  { title: '签约销售代表', dataIndex: 'contractSeller' },
  { title: '我方签约时间', dataIndex: 'contractTime' },
  { title: '客户签约时间', dataIndex: 'counterpartContractTime' },
  { title: '合同创建时间', dataIndex: 'contractCreateTime' }
])
const fetch = () => {
  if (route.query.cosId || route.query.arkCode) {
    queryContractDetail({
      arkCode: route.query.arkCode,
      cosId: route.query.cosId
    }).then((res) => {
      data.value = res.data
    })
  }
}
const viewPdf = (data: ContractItem) => {
  if (data.fileUrl) {
    const eleLink = document.createElement('a')
    eleLink.download = data.fileUrl
    eleLink.style.display = 'none'
    eleLink.href = data.fileUrl
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  } else {
    DcMessage.warning('暂无合同原件')
  }
}
// 修改合同编码
const showEditModal = (data: ContractItem) => {
  editForm.value = {
    ...data,
    newContractCode: undefined
  }
  visible.value = true
}
const updateCode = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { id, newContractCode } = editForm.value
    contractCodeUpdate({
      id,
      contractCode: newContractCode
    })
      .then((res) => {
        visible.value = false
        DcMessage.success('修改成功')
        fetch()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  fetch()
})
</script>
